<template>
    <div>
        <div>
            <v-data-table :items="notifications" :headers="notificationsHeaders" disable-pagination disable-sort hide-default-footer :items-per-page="-1" class="v-data-table--default">
                <span slot="item.no" slot-scope="{item}">
                    <v-icon v-if="item.isNotice" color="yellow darken-2">mdi-alert-circle-outline</v-icon>
                    <span v-else>{{ (page - 1) * limit + +notifications.filter(noti => !noti.isNotice).indexOf(item) + 1 }}</span>
                </span>
                <router-link slot="item.subject" slot-scope="{item}" :to="`/center/notifications/${item._id}`" class="d-block font-weight-medium text-truncate">{{ item.subject }}</router-link>
                <span slot="item.writer.name">관리자</span>
                <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</span>
            </v-data-table>
        </div>

        <div class="mt-30px mt-md-40px">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)"/>
        </div>

        <div class="mt-30px mt-md-40px">
            <v-divider />
            <div class="grey lighten-4 pa-12px py-md-20px">
                <div class="mw-500px mx-auto">
                    <v-row align="center" class="row--x-small">
                        <v-col cols="12" md="auto">
                            <v-select v-model="filter.searchKey" :items="searchKeyItems" item-text="text" item-value="value" outlined hide-details class="white mw-md-180px" @input="value => filter.searchValue = value ? filter.searchValue : ''"/>
                        </v-col>
                        <v-col cols="12" md="">
                            <v-row align="center" class="row--x-small">
                                <v-col>
                                    <v-text-field v-model="filter.searchValue" outlined hide-details clearable class="white" :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true);"/>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn @click="page = 1; search(true)" color="primary" class="v-btn--input w-80px">검색</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-divider />
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {

            filter: {
                searchKey: "",
                searchValue: ""
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            notifications: [],
            notificationsHeaders: [
                { text: "No", value: "no", align: "center", width: "8%" },
                { text: "제목", value: "subject", align: "left", width: "64%" },
                { text: "작성자", value: "writer.name", align: "center", width: "14%" },
                { text: "작성일자", value: "createdAt", align: "center", width: "14%" },
            ],

			searchKeyItems: [
				{ text: ":: 검색조건 ::", value: "" },
				{ text: "제목", value: "subject" },
				{ text: "내용", value: "content" },
				{ text: "제목+내용", value: "subject+content" },
				{ text: "작성자", value: "writer.name" },
				{ text: "아이디", value: "writer.username" },
			]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { notifications: statics } = await api.v1.center.notifications.gets({
                headers: { limit: 0 },
                params: { isNotice: true }
            });

            let { summary, notifications } = await api.v1.center.notifications.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });


            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.notifications = [ ...statics, ...notifications ];
        },

    },
    watch: {
        "$route.query": {
            deep: true,
            handler(){
                this.page = +this.$route.query.page || 1;
                this.search(false);
                window.scrollTo({ top: 0 });
            }
        }
    }
}
</script>

<style scoped>
@media (max-width:1024px){
}
@media (max-width:992px){
}
@media (max-width:600px){
    >>>.v-data-table--default table >tbody >tr >*:nth-child(1){display:none !important;}
    >>>.v-data-table--default table >tbody >tr >*:nth-child(3),
    >>>.v-data-table--default table >tbody >tr >*:nth-child(4){
        display: inline-block !important;
        border-bottom: none !important;
    }
    >>>.v-data-table .v-data-table__mobile-table-row>.v-data-table__mobile-row:last-child{
        border-bottom: none !important;
    }
    >>>.v-data-table--default>.v-data-table__wrapper>table>tbody>tr{
        border-bottom:1px solid #bdbdbd !important;
    }
}
@media (max-width:576px){
}
</style>